import React from "react";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

export const CardTable = ({ title, children, currentValue, updateValue, listValues, hasFilters = false }) => {
    return (
        <div className=" card w-full h-full flex  relative ">
            <div className="title-card">
                <div className="flex flex-row justify-between items-end">
                    <div>
                        <h2 className="text-xs font-bold leading-normal">{title}</h2>
                    </div>

                    <div className="flex flex-row justify-between items-end ">
                        {hasFilters && <p className="text-lowGray mr-[12px]">Limpiar todos los filtros</p>}
                        <span>
                            <Dropdown
                                menu={{ items: listValues, onClick: (data) => updateValue(data.key) }}
                                className="flex items-center justify-center w-[62px] h-[22px] text-xs "
                            >
                                <Button>
                                    <Space>
                                        {currentValue}
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                        </span>
                    </div>
                </div>
            </div>

            <div className=" overflow-x-auto h-full w-full grow ">{children}</div>
        </div>
    );
};
